const cartExitPopupElement = document.getElementById('cartExitPopup');
const timeToShow = cartExitPopupElement.dataset.time;

document.addEventListener("DOMContentLoaded", () => {
    // Trigger popup when the page is loaded
    initExitPopup();
});
// Set idle timeout to trigger popup if conditions met
function setIdleTimeout(millis, getCartProducts) {
    let timeout = 0;
    startTimer();
    function startTimer() {
        timeout = setTimeout(onExpires, millis);
        document.addEventListener("touchmove", onActivity);
        document.addEventListener("keypress", onActivity);
        document.addEventListener("scroll", onActivity);
        document.addEventListener("click", onActivity);
    }
    function onExpires() {
        timeout = 0;
        const mobilecartCount = parseInt(document.querySelector(".cart-count-bubble span").textContent);
            if (mobilecartCount > 0 && sessionStorage.getItem("popupShowed") === null) {
                getCartProducts();
            }
    }
    function onActivity() {
        if (timeout) clearTimeout(timeout);
        document.removeEventListener("touchmove", onActivity);
        document.removeEventListener("keypress", onActivity);
        document.removeEventListener("scroll", onActivity);
        document.addEventListener("click", onActivity);
        startTimer();
    }
  
}
function getItemFromLocalStorage(key) {
    let retrievedValue = localStorage.getItem(key);
    if(retrievedValue) {
        return retrievedValue;
    } else {
        return '';
    }
}
function checkProductIsInWishlist(product) {
    let wishlistItems = this.getItemFromLocalStorage('_ftcWishlist') ? JSON.parse(this.getItemFromLocalStorage('_ftcWishlist')) : [];
    let prodItem = product.id + ',' + product.handle;
    return wishlistItems.includes(prodItem);
}
// Get the button element
let closeModal = document.getElementById("ModalClose-exit-modal");
let modal = document.querySelector(".modal__container");

// Add a click event listener to close the popup
closeModal.addEventListener("click", function (e) {
    e.preventDefault();
    modal.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
});
// Replace header texttext
const replaceText = (replacement) => {
    const originalTextElement = document.querySelector(".modal__container .title");
    const originalText = originalTextElement.textContent; // Get the original text content
    const newText = originalText.replace('{{cart.item_count}}', replacement); // Replace "{{X}}" with the provided replacement
    originalTextElement.textContent = newText; // Update the text content of the element
};

const getCartProducts = () => {
    // Fetch cart products data
    fetch("/cart.js")
        .then(response => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            
            return response.json();
        })
        .then(data => {
            console.log(data);
            replaceText(data.item_count);
            updateSlider(data.items);
        })
        .catch(error => {
            console.error("Error fetching cart data:", error);
        });

  console.log('popup triggered')
};

const updateSlider = (cartItems) => {
    const sliderContainer = document.getElementById('Slider-exit-popup');
    const activeCartCurrency = sliderContainer.dataset.cartCurrency;
    
    sliderContainer.classList.add(cartItems.length == 1 ? "one-product" : "multiple-product");
    console.log(sliderContainer,cartItems.length);
    // Clear previous content
    sliderContainer.innerHTML = '';
    // Loop through each cart item and generate HTML for each product
    cartItems.forEach((product, index) => {
        const slide = document.createElement('li');
        slide.id = `Slide-exit-popup-${index + 1}`;
        slide.className = 'grid__item';
        let isInWishlist = checkProductIsInWishlist(product);
        let wishlistAddedClass = isInWishlist ? ' wishlist-added' : '';

        slide.className += ' slider__slide';

        const cardProductHTML = `<div class="card-wrapper">
          <div class="card card--standard card--media" style="--ratio-percent: 139%;" product-price= "${product.price / 100.0}" >
              <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 139%;">
                  <div class="card__media">
                      <a href="${product.url}" class="media media--transparent media--hover-effect">
                          <img src="${product.featured_image.url}&width=700" alt="${product.title}" class="motion-reduce" loading="lazy" width="700" height="700">                             
                      </a>
                      <div class="cart-count-bubble">
                      <span aria-hidden="true">${product.quantity}</span>
                      <span class="visually-hidden">${product.quantity} items</span>
                      </div>
                  </div>
                  <div class="card__content">
                      <div class="card__information">
                          <h4 class="card__heading">
                              <a href="${window.Shopify.routes.root + 'products/' + product.handle}" class="card__information--title recently-viewed-product ${product.handle}" title="${product.title}">${product.title}</a>
                          </h4>
                      </div>
                      <div class="card__wishlist-icon ${wishlistAddedClass}" data-wishlist="" data-product-handle="${product.handle}" data-product-id="${product.id}"  data-variant-id="${product.id}" wishlist-id="${product.id}" aria-label="Wishlist" title="Wishlist">
                          <span class="card__icon-heart-empty"><svg class="icon icon-heart-empty" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>Wishlist</title>
                          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Desktop_Double_Label" transform="translate(-217.000000, -17.000000)" fill="#707070" fill-rule="nonzero" stroke="#707070" stroke-width="0.3">
                                  <g id="noun_Heart_249778" transform="translate(218.000000, 17.000000)">
                                      <path d="M8.52858851,15.7668437 C8.53122701,15.764959 13.4588198,12.1213748 15.4199814,9.36074683 C19.0281343,4.27748233 15.8408227,0.251692143 12.3169134,0.251692143 C10.9859771,0.251692143 9.60754777,0.825566546 8.52840005,2.13313325 C7.44925232,0.825566546 6.07006911,0.251880607 4.73950973,0.251692143 C1.21484665,0.251126749 -1.97246498,4.2771054 1.63625327,9.36074683 C3.59741486,12.1213748 8.52858851,15.7668437 8.52858851,15.7668437 Z M1.41198052,3.20775783 C2.04409045,1.98424629 3.34977251,1.19363771 4.7391328,1.19382615 C4.7391328,1.19382615 4.73932127,1.19382615 4.73950973,1.19382615 C5.89517405,1.19382615 6.98261422,1.74037323 7.80168093,2.73282729 L8.52840005,3.6135219 L9.25511916,2.73282729 C10.0741859,1.74018477 11.1612491,1.19382615 12.316725,1.19382615 C13.7057083,1.19382615 15.0117673,1.98443476 15.6436888,3.20813476 C16.4552169,4.77917483 16.1027883,6.77049074 14.6514232,8.81495364 C13.1759346,10.8920209 9.85274009,13.558982 8.52840005,14.5827212 C7.20292922,13.5576628 3.87558846,10.8865554 2.40424611,8.8151421 C0.95306946,6.77030228 0.600640845,4.7787979 1.41198052,3.20775783 Z" id="Shape"></path>
                                  </g>
                              </g>
                          </g>
                          </svg></span>
                          <span class="card__icon-heart-filled"><svg class="icon icon-heart-filled" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19 16" style="enable-background:new 0 0 19 16;" xml:space="preserve">
                          <title>Wishlist</title>
                          <style type="text/css">.st0{fill:#e31b23;stroke:#e31b23;stroke-width:0.3;}</style>
                          <path class="st0" d="M9.5,15.8c0,0,4.9-3.6,6.9-6.4c3.6-5.1,0.4-9.1-3.1-9.1c-1.3,0-2.7,0.6-3.8,1.9C8.4,0.8,7.1,0.3,5.7,0.3
                              c-3.5,0-6.7,4-3.1,9.1C4.6,12.1,9.5,15.8,9.5,15.8z"></path>
                          </svg></span>
                      </div>
                  </div>
              </div>
              <div class="card__content">
                  <div class="card__information">
                      <h4 class="card__heading h5" id="title-template--exit-popup">
                          <a href="${window.Shopify.routes.root + 'products/' + product.handle}" class="card__information--title recently-viewed-product ${product.handle}" title="${product.title}">${product.title}</a>
                      </h4>
                      <div class="card-information">
                          <span class="caption-large light"></span>
                          <div class="price ff-price">
                              <div class="price__container">
                                  <div class="price__regular">
                                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                      <span class="cart-popup-currency">${activeCartCurrency}</span>
                                      <span class="subtitle--s price-item price-item--regular ${activeCartCurrency}" data-js-price="${product.price}">
                                       ${product.price}
                                      </span>
                                  </div>
                                  <div class="price__sale">
                                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                      <span style="display: flex;">
                                          <span class="cart-popup-currency">${activeCartCurrency}</span><s class="subtitle--s price-item price-item--regular" data-js-price="${product.price}">${product.price}</s>
                                      </span>
                                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                      <span style="display: flex;">
                                      <span class="cart-popup-currency" style="color: red">${activeCartCurrency}</span>
                                      <span class="subtitle--s price-item price-item--sale price-item--last" data-js-price="${product.price}">
                                      ${product.price}
                                      </span>
                                      </span>
                                  </div>
                                  <small class="unit-price caption hidden">
                                  <span class="visually-hidden">Unit price</span>
                                  <span class="subtitle--s price-item price-item--last">
                                      <span></span>
                                      <span aria-hidden="true">/</span>
                                      <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                      <span>
                                      </span>
                                  </span>
                                  </small>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>`

        slide.innerHTML = cardProductHTML;
        sliderContainer.appendChild(slide);
    });
    //Reset slider after items have been added
    sliderContainer.parentElement.resetPages();
    //Format prices on the new slider
    setTimeout(() => {
        window.formatPrices("#Slider-exit-popup .price-item");
    }, 10);
    //Open modal
    let modal = document.querySelector(".modal__container");
    modal.setAttribute('open', null);
    document.body.classList.add('overflow-hidden');
    // Set session storage flag to indicate popup was shown
    sessionStorage.setItem("popupShowed", "true");
};


const initExitPopup = () => {
    // Check window width for appropriate popup trigger
    if (window.innerWidth > 750) {
        // Trigger popup on mouse leave if conditions met
        // document.addEventListener("mouseleave", () => {
        //     const cartCount = parseInt(document.querySelector(".cart-count-bubble span:first-child").textContent);
        //     // console.log(cartCount,sessionStorage.getItem("popupShowed"));
        //     if (cartCount > 0 && sessionStorage.getItem("popupShowed") == null || sessionStorage.getItem("popupShowed") == 'null') {
        //         // console.log('document mouseleave cartCount',cartCount)
        //         getCartProducts();
        //     }
        // });

      setIdleTimeout(timeToShow, getCartProducts);

      
    } else {
        // Trigger popup if conditions met
        setIdleTimeout(timeToShow, getCartProducts);
        
    }
  
};

